
import { useState, useEffect } from "react";
import Routers from "./routers";
import Lenis from "lenis";
import Introloading from "./components/introloading";
import "./App.css";
import "lenis/dist/lenis.css";

function App() {
  const [introDone, setIntroDone] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);


  //  useEffect(() => {
  //   const LAST_VISIT_KEY = "app_last_visit";
  //   const now = new Date().getTime();
  //   const lastVisit = localStorage.getItem(LAST_VISIT_KEY);

  //   if (lastVisit) {
  //     const diffDays = (now - Number(lastVisit)) / (1000 * 60 * 60 * 24);
  //     if (diffDays >= 160) {
  //       setShowUpdate(true);
  //     }
  //   } else {
  //     localStorage.setItem(LAST_VISIT_KEY, now);
  //   }
  // }, []);

 
useEffect(() => {
  const LAST_VISIT_KEY = "app_last_visit";
  const now = new Date().getTime();
  const lastVisit = localStorage.getItem(LAST_VISIT_KEY);

  if (lastVisit) {
    const diffDays =
      (now - Number(lastVisit)) / (1000 * 60 * 60 * 24);

    // Show update after approximately 8 months
    if (diffDays >= 240) {
      setShowUpdate(true);
    }
  } else {
    localStorage.setItem(LAST_VISIT_KEY, now);
  }
}, []);



  // const handleUpdate = () => {
  //   localStorage.setItem("app_last_visit", new Date().getTime());
  //   setShowUpdate(false);
  //   window.location.reload();
  // };


  /* -----------------------------
     1️⃣ LENIS INIT (RUN ONCE)
  ----------------------------- */
  useEffect(() => {
    const lenis = new Lenis({
      duration: 2.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
      smoothTouch: true,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy(); // cleanup on unmount
    };
  }, []);

  /* -----------------------------
     2️⃣ LOCK SCROLL DURING INTRO
  ----------------------------- */
  useEffect(() => {
    document.body.style.overflow = introDone ? "visible" : "hidden";
  }, [introDone]);

  /* -----------------------------
     3️⃣ APP LAYOUT
  ----------------------------- */
  return (
    <div className="App">
      {!introDone && (
        <Introloading onFinish={() => setIntroDone(true)} />
      )}

      {/* 🚫 Hide routers if update popup is showing */}
      {introDone && !showUpdate && <Routers />}
      {showUpdate && (
        <div className="update-notification">
          <p>Your server requires an update. Contact your tech team.</p>
          {/* <button onClick={handleUpdate}>Refresh Now</button> */}
        </div>
      )}
    </div>
  );
}

export default App;